export const RESERVE_RESERVATION_SETTINGS_FIELD_ACCEPTS_ONLINE =
  "Accepts Online Reservations";
export const RESERVE_RESERVATION_SETTINGS_FIELD_MAX_PARTY_SIZE =
  "Max Party Size";
export const RESERVE_RESERVATION_SETTINGS_FIELD_DAYS_IN_ADVANCE =
  "Days In Advance for Reservations";
export const RESERVE_RESERVATION_SETTINGS_FIELD_CUT_OFF_MINUTES =
  "Reservation Cut-Off Minutes";
export const RESERVE_RESERVATION_SETTINGS_FIELD_CLOSE_SAME_DAY_TIME =
  "Close Same Day Reservations Time";
export const RESERVE_RESERVATION_SETTINGS_FIELD_MIN_TIME_TO_CANCEL =
  "Minimum Time to Cancel Reservation";
export const RESERVE_RESERVATION_SETTINGS_FIELD_SLOTTING =
  "Automatic or Manual Slotting";
export const RESERVE_RESERVATION_SETTINGS_FIELD_HELD_AFTER_RES_TIME =
  "Reservation to be held after res time";
export const RESERVE_RESERVATION_SETTINGS_FIELD_AUTO_SUGGEST_TABLES =
  "Auto Suggest Tables";
export const RESERVE_RESERVATION_SETTINGS_FIELD_NO_SHOW_FEE_AMOUNT =
  "No show Fee Amount";
export const RESERVE_RESERVATION_SETTINGS_FIELD_NO_SHOW_FEE_TYPE =
  "No show Fee Type";
export const RESERVE_RESERVATION_SETTINGS_FIELD_NO_SHOW_FEE_SCHEDULE =
  "No show Fee Schedule";
export const RESERVE_RESERVATION_SETTINGS_FIELD_NO_SHOW_APPLIES_PARTY_SIZE =
  "No show Applies to Party Size";

export const RESERVE_RESERVATION_SETTINGS_CLOSE_SAME_DAY_OPTIONS = [
  "No Restrictions",
];

export const RESERVE_RESERVATION_SETTINGS_SLOTTING_OPTIONS = [
  "Automatic - System will auto assign table (Most Common, tables can still be adjusted)",
  "Manual",
];

export const RESERVE_RESERVATION_SETTINGS_NO_SHOW_FEE_TYPE_OPTIONS = [
  "Per cover",
  "Per reservation",
];

export const RESERVE_RESERVATION_SETTINGS_NO_SHOW_FEE_SCHEDULE_OPTIONS = [
  "Same every day",
  "Different on certain days of the week",
];

export const RESERVE_RESERVATION_SETTINGS_DEFAULTS = {
  [RESERVE_RESERVATION_SETTINGS_FIELD_ACCEPTS_ONLINE]: "Yes",
  [RESERVE_RESERVATION_SETTINGS_FIELD_MAX_PARTY_SIZE]: "6",
  [RESERVE_RESERVATION_SETTINGS_FIELD_DAYS_IN_ADVANCE]: "365",
  [RESERVE_RESERVATION_SETTINGS_FIELD_CUT_OFF_MINUTES]: "15",
  [RESERVE_RESERVATION_SETTINGS_FIELD_CLOSE_SAME_DAY_TIME]: "No Restrictions",
  [RESERVE_RESERVATION_SETTINGS_FIELD_MIN_TIME_TO_CANCEL]: "12 hours",
  [RESERVE_RESERVATION_SETTINGS_FIELD_SLOTTING]:
    RESERVE_RESERVATION_SETTINGS_SLOTTING_OPTIONS[0],
  [RESERVE_RESERVATION_SETTINGS_FIELD_HELD_AFTER_RES_TIME]: "15",
  [RESERVE_RESERVATION_SETTINGS_FIELD_AUTO_SUGGEST_TABLES]: "Yes",
  [RESERVE_RESERVATION_SETTINGS_FIELD_NO_SHOW_FEE_AMOUNT]: "",
  [RESERVE_RESERVATION_SETTINGS_FIELD_NO_SHOW_FEE_TYPE]: "",
  [RESERVE_RESERVATION_SETTINGS_FIELD_NO_SHOW_FEE_SCHEDULE]: "",
  [RESERVE_RESERVATION_SETTINGS_FIELD_NO_SHOW_APPLIES_PARTY_SIZE]: "",
} as const;
